import Button from "../components/button/Button"
import FAQItem from "../components/questions/Questions"
import styles from "./ForthScreen.module.css"


const ForthScreen = () => {
  return (
    <>
      <div className={styles.title}>אתן שואלות ואני עונה</div>
      
      {/* שאלות על הלמידה הדיגיטלית */}
      <FAQItem 
        question="מה אם אני לא מבינה בטכנולוגיה בכלל.. אני אסתדר עם הקורס הדיגיטלי?" 
        answer="תשכחי מהטכנולוגיה! הקורס שלי בנוי כל כך בפשטות שאת צריכה רק לדעת איך להדליק מחשב. כל שלב מצולם בבהירות מושלמת, עם הסברים מילה במילה כמו שהיית יושבת לידי בסטודיו. בנוסף, אני והצוות כאן בשבילך לכל שאלה - אף בחורה לא נשארת לבד!" 
      />
      

      <FAQItem 
        question="מה אם יש לי שאלות באמצע הקורס? מי יעזור לי?" 
        answer="אני והצוות תמיד כאן! כל מי שרוכשת את הקורס הדיגיטלי הופכת להיות חלק מהמשפחה. לכל שאלה את יכולה לפנות אלינו ותקבלי את המענה עד שהכל יהיה ברור, את אפילו להגיע לאקדמיה להתאמן על מודליסטיות במידה ומשהו לא יושב אצלך מספיק טוב" 
      />

      <FAQItem 
        question="למדתי מיקרו בעבר ולא הצלחתי, למה שהפעם יהיה שונה?" 
        answer=" אני מבינה את החשש מלהכשל שוב - הייתי שם! חשוב לי שתדעי שמאות בנות שעברו אצלי, הגיעו אחרי שהן עברו קורסים כושלים בעבר - והיום הן עובדות בביטחון מלא. השיטה שלי RL היא לא עוד טכניקה, היא מונעת טעויות מהבסיס. אני לא מלמדת אותך 'עוד דרך' - אני עושה לך סדר מלא מאפס. פה את לומדת את הכל לעומק, עם 6 טיפולים מצולמים במלואם ו50 שעות יחד איתי ועם החומר, מה שיקבע אם הפעם זה יהיה שונה זו את, ההתמדה שלך, התרגול והגישה שתגיעי איתה" 
      />

<FAQItem 
  question="מה מייחד את השיטה RL שהפעם יעשה אצלי שינוי?" 
  answer="שיטת RL היא לא עוד טכניקה, היא פרי הפיתוח שלי אחרי שנים של מחקר וניסיון, והיא הפכה בשנים האחרונות לשיטה המבוקשת ביותר בתחום. הטכניקה בנויה כך שתיקחי שליטה מלאה מהבסיס ועד לפרטים הקטנים ביותר – משירטוט השיערות, דרך בחירת הצבעים, ועד דיוק המחט והבנת סוגי העור. השילוב הייחודי של כל האלמנטים האלו קיים רק אצלנו, ולכן לא תמצאי טכניקה זהה בשום מקום אחר. זו הסיבה שבוגרות שלנו הופכות למובילות בשוק, והפעם גם את תוכלי להגיע לתוצאות שמרגישות מקצועיות ובטוחות באמת."
/>



      <FAQItem 
        question="אני מפחדת שאני באמת לא מספיק טובה כדי להצליח" 
        answer="יקירה, אני הייתי בדיוק במקום שלך! סיימתי קורס ועזבתי את התחום כי לא היה לי בטחון והייתי בטוחה שאני לא אחזיק את המחט לעולם יותר. אבל הבנתי משהו - אף אחת לא נולדה מאסטרית. הטכניקה שלי RL נבנתה בדיוק בשביל בנות כמוך - בנות שרוצות לעבוד בביטחון מלא למרות שהוא לא קיים ב100% עכשיו. עם השיטה שלי אני בטוחה שהבטחון שלך יחזור ותוכלי להתחיל לעבוד במקצועיות עם חיוך ולהפוך את התשוקה שלך לקריירה אמיתית!" 
      />

   <FAQItem 
        question="אני בשנים הראשונות שלי בתחום.. איך אדע אם זה הזמן המתאים עבורי?" 
        answer="אני מבינה את ההתלבטות שלך אבל חשוב לי שתדעי - הרגע המושלם לא יגיע אף פעם! תמיד יהיה משהו שיעצור אותנו, אבל כשאת עושה צעד את מתחייבת לעצמך ומתחילה לזוז קדימה במקום להיתקע. דחיינות רק גורמת לך לחשוב ולהתעכב עוד ועוד, בתקווה ש'יהיה זמן אחר כך', אבל בפועל היא מוסיפה אפילו לחץ וחשש שמצטברים עם הזמן. אם את באמת רוצה להתקדם, תתחילי היום – לא כשתרגישי שהרגע מושלם"
      />
  <FAQItem 
        question="רחלי, איך אני אדע שההשקעה לא גדולה עלי בשלב הזה?" 
        answer="כי גם אני הייתי בדיוק שם.. גם לי זה היה יקר.. הסיפור האישי שלי על שינוי התודעה, התפיסה.. שמעבר לכך שגרמה לי להבין שהשקעה בעצמי ובתחום שאני רוצה להצליח בו לא יכולה להיות יקרה.. התפיסה הזאת , בפריצת מחסומים האלה.. הלמידה לחפור בתת מודע ולהבין עם עצמי בכנות מה הסיבות שבאמת עוצרות אותי מלהתקדם.. לבסוף כמעט תמיד אני מגיעה למסכנה - זה יושב על הפחדים שלי.. ואותם אני מנצחת!  תשאירי פרטים ואולי גם את תנצחי את שלך "
      />
<FAQItem 
  question="כמה מהר אני אראה תוצאות מהקורס?" 
  answer="הקצב משתנה מאחת לאחת, וזה טבעי. חלק מרגישות שינוי כבר בימים הראשונים, לאחרות זה לוקח קצת יותר זמן. מה שחשוב הוא להמשיך ליישם ולהיות עקבית. כל צעד שתעשי יביא אותך קרוב יותר למטרה, ובדרך תגלי יכולות שלא חשבת שיש בך. מה שבטוח הוא שאם תתחילי את תראי תוצאות! אבל אם לא תתחילי.. המצב יישאר כמו שהוא"
/>


      <Button text="רחלי, קחי אותי לקורס!"/>
      

    </>
  )
}

export default ForthScreen